<h2 mat-dialog-title>
  <span>{{ isEditMode ? "Edit" : "Add" }} User</span>
  <div class="subtitle">
    {{
      isEditMode
        ? "Edit the user details for this merchant."
        : "Add a new users associate to the selected Partner’s branch."
    }}
  </div>
</h2>

<mat-dialog-content [formGroup]="form">
  <div class="pv-xs" fxLayout="column">
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input formControlName="name" matInput placeholder="e.g., Ahmad Rizal" />
      <mat-error *ngIf="form.get('name').hasError('required')">
        Name is required
      </mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field appearance="outline" fxFlex="50%">
        <mat-label>Mobile No.</mat-label>
        <ngx-mat-intl-tel-input
          #mobileNo
          [enablePlaceholder]="true"
          [enableSearch]="true"
          [preferredCountries]="['my']"
          formControlName="mobileNo"
          name="mobileNo"
        ></ngx-mat-intl-tel-input>
        <mat-error *ngIf="form.get('mobileNo').hasError('required')">
          Mobile No. is required
        </mat-error>
        <mat-error *ngIf="form.get('mobileNo').hasError('validatePhoneNumber')">
          Invalid Mobile No.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="50%">
        <mat-label>Email Address</mat-label>
        <input
          formControlName="email"
          matInput
          placeholder="branch@company.com"
          type="email"
        />
        <mat-error *ngIf="form.get('email').hasError('required')">
          Email is required
        </mat-error>
        <mat-error *ngIf="form.get('email').hasError('email')">
          Invalid email address
        </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Select Branch</mat-label>
      <mat-select formControlName="branchId" placeholder="Select which branch">
        <mat-option *ngFor="let branch of branches" [value]="branch.id">
          {{ branch.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('branchId').hasError('required')">
        Branch is required
      </mat-error>
    </mat-form-field>

      <div fxLayout="row" fxLayoutGap="16px">
          <mat-form-field appearance="outline" style="flex: 1;">
              <mat-label>User Role</mat-label>
              <mat-select formControlName="role" placeholder="Select role">
                  <mat-option *ngFor="let role of roles" [value]="role.value">
                      {{ role.label }}
                  </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('role').hasError('required')">
                  Role is required
              </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="isEditMode" appearance="outline" style="flex: 1;">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status" placeholder="Select status">
                  <mat-option *ngFor="let status of userStatuses" [value]="status.value">
                      {{ status.label }}
                  </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('status').hasError('required')">
                  Status is required
              </mat-error>
          </mat-form-field>
      </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="onCancel()" mat-button>Cancel</button>
  <button
    (click)="onNext()"
    [disabled]="form.invalid || (isEditMode && !isFormChanged)"
    color="primary"
    mat-raised-button
  >
    {{ isEditMode ? "Update" : "Add" }} User
  </button>
</mat-dialog-actions>
